//mui
import { styled } from "@mui/material/styles";
import Popper from "@mui/material/Popper";

const StyledPopper = styled(Popper)(({ theme }) => ({
  padding: 0,
  margin: 0,
  "& .MuiPaper-root": {
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: "10px",
  },
  "& .MuiAutocomplete-listbox": {
    padding: "8px 0",
    "&::-webkit-scrollbar": {
      width: "0.4em",
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#9A9A9A",
      borderRadius: "30px",
    },
    "& .MuiAutocomplete-option": {
      padding: "12px 16px",
    },
    "& li": {
      fontSize: "14px",
      [theme.breakpoints.down("xl")]: {
        fontSize: "12.5px",
      },
      [theme.breakpoints.down("lg")]: {
        fontSize: "11px",
      },
    },
  },
}));

const CustomPopperCheckbox = (props) => {
  return <StyledPopper {...props} placement="bottom" />;
};

export default CustomPopperCheckbox;